import React from 'react';
import { NextPage } from 'next';
import { ISupportPageData, SUPPORT_PAGE_TYPE } from 'src/core/types';
import { ArticlePage, CategoryPage } from 'src/components/pages';
import { getArticleOrCategoryPageProps } from 'src/helpers/config/getArticleOrCategoryPageProps';

const InternetArticlePage: NextPage<ISupportPageData> = ({ data }: ISupportPageData) => {
  const PageComponent = data.type === SUPPORT_PAGE_TYPE.category ? CategoryPage : ArticlePage;
  return <PageComponent data={data} />;
};

export const getServerSideProps = getArticleOrCategoryPageProps;

export default InternetArticlePage;
